import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { CognitoAccessToken } from 'amazon-cognito-identity-js'
import { Observable } from 'rxjs'
import { switchMap } from 'rxjs/operators'
import { AuthFacade } from '../../auth/auth.facade'

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    private auth: AuthFacade = inject(AuthFacade)

    intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        req = req.clone()

        return this.auth.getActiveAccessToken().pipe(
            switchMap((token: CognitoAccessToken) =>
                next.handle(
                    req.clone({
                        setHeaders: {
                            Authorization: `Bearer ${token.getJwtToken()}`
                        }
                    })
                )
            )
        )

        return next.handle(req)
    }
}
